var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge",class:_vm.badgeClass},[_c('font-awesome-icon',{attrs:{"icon":_vm.iconName}}),_vm._v("\n     "+_vm._s(_vm.$t(`kycRequest.status.${_vm.status}`))+"\n  ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }